import React, { Component } from 'react';
import { PnkHtmlForm } from '../../../pnk-react/pnk-controls/pnk-html-form';
//import PnkImage from '../../pnk-react/pnk-ctrl/pnk-image'


export default class CategoryForm extends Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <div>
                <div class="add-organizer-form-main">
                    {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <a>Back</a>
        </div>  */}
                    <div className="add-organizer-form-main-div">


                        <div class="container-fluid">
                           

                            <PnkHtmlForm id="frmCategoryEntry" onsubmit={this.props.SaveCategoryEntryData} submitbtn="btnCategoryEntry" style={{ marginTop: '20px' }}>
                               
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Category Name</label>
                                            <input type="text" class="form-control form2-control-ausi"
                                                id="txtCategoryName"
                                                name="txtCategoryName"
                                                placeholder="Category Name"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtCategoryName}
                                                value={this.props.mystate.txtCategoryName}
                                                onBlur={this.props.HandleCategoryInput}
                                                pnkdisplayerrormsg="Invalid Category Name"

                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Status</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlCategoryStatus"
                                            name="ddlCategoryStatus"
                                            //placeholder="Event Name"
                                            // pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlCategoryStatus}
                                            value={this.props.mystate.ddlCategoryStatus}
                                            onChange={this.props.HandleCategoryInput} >
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                   
                                </div>
                                <button class="btn add-organizer-btn pnkvalidatesubmit" id="btnCategoryEntry" name="save" onClick={() => this.props.SaveCategoryEntryData} >Add Category</button>
                            </PnkHtmlForm>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}